import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text, VStack } from '@chakra-ui/react';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { formLabelStyling, stackStyling, descriptionStyling } from 'components/forms/new/formStyles';
import { Field } from 'formik';
import NameField from 'components/forms/new/formikFormFields/NameField';



const PrefixPatternInputField = ({ errors, touched, darkMode, type, values }) => {
    const [isHovered, setIsHovered] = useState(false);
    const label = type === 'prefix' ? 'Prefix' : 'Pattern';
    const description = type === 'prefix'
        ? 'Enter the prefix for this block rate.'
        : 'Enter the pattern for this block rate.';
    const tooltiptext = type === 'prefix'
        ? 'Prefix Example: 61 to match numbers starting in 61, 61[23] matches numbers starting in 612 or 613'
        : 'pattern example:\n(Using Perl Regular Expression)\n^ - Start of line\n$ - End of line\n[] - list of possibilities\n() - for grouping\n{[min],[max]} - length (quantity) range\n^61[234][0-9]{8}$ = matches a number that start with 612, 613, 614, and is followed by 8 additional numbers exactly';
    const fieldName =  (type === 'prefix' ? 'prefix' : 'pattern');
    const error = errors[fieldName];
    const showError = touched[fieldName];
    console.log(values)
    return (
        <FormControl sx={{ margin: '0 !important' }} isInvalid={!!error && showError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        {label} <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        {description}
                    </Text>
                </Box>
                <Box flex="1" minWidth="250px" >
                    <VStack width="100%" alignItems="normal">
                       <Field name={fieldName} >
                           {({ meta }) => (
                               <>
                                   <Field
                                       as={NameField}
                                       id={fieldName}
                                       name={fieldName}
                                       error={meta.touched ? meta.error : undefined}
                                       customWidth="100%"
                                   />
                                   {meta.touched && meta.error && (
                                       <Text color="red.500" fontSize="xs" mt={1} textAlign="right">
                                           {meta.error}
                                       </Text>
                                   )}
                               </>
                           )}
                       </Field>
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label={tooltiptext}
                        ariaLabel={`number-block-${type.toLowerCase()}-tip`}
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default PrefixPatternInputField;
